import { AllStatusesTypes } from 'interfaces';

type BroadcastByStatusParams = {
  status: AllStatusesTypes;
  isOwner?: boolean;
};

export const broadcastKeys = {
  all: ['broadcasts'] as const,
  favourites: [...(['broadcasts'] as const), 'favourites'] as const,
  broadcast: (id: string) => [...broadcastKeys.all, id] as const,
  broadcastByStatus: (params: BroadcastByStatusParams) =>
    [...broadcastKeys.all, params] as const,
};
